var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVariable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.001,
    height: 16,
    viewBox: "0 0 21.001 16",
    fill: "#445062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(-24 -839)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "n",
    transform: "translate(31 850)",
    fontSize: 10,
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700,
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "n")), /*#__PURE__*/React.createElement("g", {
    id: "chevron-down",
    transform: "translate(32 839) rotate(90)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "chevron-down-2",
    "data-name": "chevron-down",
    d: "M5.335,9.707l6.857,6a1.26,1.26,0,0,0,1.616,0l6.857-6a.913.913,0,0,0,0-1.414,1.261,1.261,0,0,0-1.616,0L13,13.586,6.951,8.293a1.26,1.26,0,0,0-1.616,0,.914.914,0,0,0,0,1.414Z",
    transform: "translate(-5 -8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "chevron-down-3",
    "data-name": "chevron-down",
    transform: "translate(37 855) rotate(-90)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "chevron-down-4",
    "data-name": "chevron-down",
    d: "M5.335,9.707l6.857,6a1.26,1.26,0,0,0,1.616,0l6.857-6a.913.913,0,0,0,0-1.414,1.261,1.261,0,0,0-1.616,0L13,13.586,6.951,8.293a1.26,1.26,0,0,0-1.616,0,.914.914,0,0,0,0,1.414Z",
    transform: "translate(-5 -8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariable);
export default __webpack_public_path__ + "static/media/variable.3a880005d97196ceebeb17f757be7e72.svg";
export { ForwardRef as ReactComponent };